module.exports = __webpack_public_path__ + "c6de102f918c622674464cd0966c41c0.svg";